<template>
  <div class="copy-export-job-modal">
    <v-dialog v-model="dialog" :max-width="maxWidth" persistent>
      <v-row class="loader fill-height py-6" align="center" justify="center" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }" v-else>
        <v-card-title class="justify-space-between">
          <div class="copy-export-job-modal--title fw-600" :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs }">
            Copy Export Job
          </div>
          <v-btn v-if="!breakpointXs" icon @click="$emit('close-export-job-modal')">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <div class="epcg-tab__table__body mt-5">
            <v-data-table :headers="tableHeaders" :items="exportJobs" :search="search"
              ><template v-slot:item.action="{ item }">
                <v-btn
                  color="indigo"
                  :loading="isCopyButtonLoading"
                  class="info font-weight-bold mx-2"
                  dense
                  @click="copyActionHandler(item)"
                  >Copy</v-btn
                >
              </template></v-data-table
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import { GET_EXPORT_JOBS } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
import * as AT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
export default {
  name: "CopyExportJobModal",
  components: {},
  data() {
    return {
      dialog: true,
      search: null,
      exportJobs: [],
      loading: false,
      isCopyButtonLoading: false
    };
  },
  props: {
    maxWidth: {
      type: String,
      default: "1050"
    },
    srNo: {
      type: Number,
      default: 1
    }
  },
  mixins: [commonMethodsMixin],
  mounted() {
    this.getExportJobs(this.globalTimePeriodId);
  },
  methods: {
    getExportJobs(timePeriodId) {
      this.loading = true;
      this.$store
        .dispatch(GET_EXPORT_JOBS, timePeriodId)
        .then(res => {
          if (res) {
            this.exportJobs = res;
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyActionHandler(exportJob) {
      const currentJobName = this.$store.state.ExportModuleStore.sbMain.jobName;
      const currentJobDate = this.$store.state.ExportModuleStore.sbMain.jobDate;
      this.isCopyButtonLoading = true;
      this.$store
        .dispatch(AT.EDIT_EXPORT_JOB, { exportJobId: exportJob.id })
        .then(res => {
          if (res) {
            this.$store.commit(MT.SET_EXPORT_JOB, { exportJob: res.job_data });
            this.$store.commit(MT.SET_EXPORT_JOB_ID, { id: res.id });
            // setting job name and job date back as previous
            this.$store.commit(MT.SET_SBMAIN_NAME, { value: currentJobName });
            this.$store.commit(MT.SET_SBMAIN_DATE, { value: currentJobDate });
            this.$emit("close-export-job-modal");
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isCopyButtonLoading = false;
        });
    }
  },
  computed: {
    tableHeaders() {
      return [
        {
          text: "Job Name",
          value: "jobName",
          align: "center"
        },
        {
          text: "Job Date",
          value: "jobDate",
          align: "center"
        },
        {
          text: "Exporter Name",
          value: "exporterName",
          align: "center"
        },
        {
          text: "Containers",
          value: "noOfContainers",
          align: "center"
        },
        {
          text: "Invoice",
          value: "invoiceName",
          align: "center"
        },
        {
          text: "Foreign Port",
          value: "portCodeOfDestinationDropdownValue",
          align: "center"
        },
        {
          text: "Action",
          value: "action",
          align: "center"
        }
      ];
    }
  }
};
</script>
